import React from 'react';
import { Button } from '@telus-uds/components-web';

import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { StatusBarWrapper, BoxWrapper } from './css';

const BrpStatusBar = ({ onProceedClick, onBackClick, step, isLastStep }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    formButtons: { continueButtonLabel, backLabel, submitButtonLabel }
  } = localizedStrings;

  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
          <>
            {step > 1 && (
              <Button variant={{ priority: 'high' }} type="button"
                onClick={onBackClick}>
                {backLabel}
              </Button>
            )}

            <Button
              type="button"
              onClick={e => onProceedClick(e)}
              style={{ marginLeft: '1em' }}
              variant={{ priority: 'high' }}
            >
              {isLastStep ? submitButtonLabel : continueButtonLabel}
            </Button>
          </>
        </BoxWrapper>
      </div>
    </StatusBarWrapper>
  );
};

BrpStatusBar.propTypes = {
  step: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired
};

export default BrpStatusBar;
